/**
 * Fetches transactions for a wallet from the transactions collection.
 * Wallets from the list endpoint have transactions: [] — this hook loads them separately.
 */

import { useQuery } from "@tanstack/react-query";
import { dataProviders } from "../services/data";

export function useWalletTransactions(walletId: string | undefined) {
	return useQuery({
		queryKey: ["walletTransactions", walletId],
		queryFn: () =>
			walletId
				? dataProviders.wallet.getTransactions(walletId)
				: Promise.resolve([]),
		enabled: !!walletId,
		staleTime: 30_000,
	});
}
